import { API_PREFIX } from "app/constants";
import to from "core/util/fetch/awaitToJs";
import superagent from "superagent";

const cancellationUriPrefix = `${API_PREFIX}/vehicle-change-attachment`;

const uploadAttachment = async (idObject, idChange, attachmentType, fileData) => {
    return await to(
        superagent
            .put(`${cancellationUriPrefix}/${idObject}/attachment/${idChange}/upload/${attachmentType}`)
            .send(fileData)
            .set("Content-Type", "application/json")
            .accept("json"),
    );
};

const deleteAttachment = async (idObject, idChange, idAttachment) => {
    return await to(superagent.delete(`${cancellationUriPrefix}/${idObject}/attachment/${idChange}/delete/${idAttachment}`));
};

export default {
    uploadAttachment,
    deleteAttachment,
};
